import {
  SET_SPORTS_BOOK_EVENTS_COUNT,
  SET_PREVIEW_FILTERS
} from 'Store/constants';

const initialState = {
  filteredCount: 0,
  previewFilters: null
};

export default (state = initialState, action) => {
  switch (action.type) {

    case SET_SPORTS_BOOK_EVENTS_COUNT:
      return {
        ...state,
        filteredCount: action.payload
      };

    case SET_PREVIEW_FILTERS:
      return {
        ...state,
        previewFilters: action.payload
      };

    default:
      return state;
  }
};
